
import { defineComponent, inject } from '@vue/composition-api';
import { User } from '@/types';

export default defineComponent({
  name: 'UserButton',
  setup() {
    const user = inject('user') as User;
    return {
      user,
    };
  },
});
